import 'firebase/auth';

export default {};
